/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { AnimatePresence, motion } from "framer-motion";
import { ElementType, FC, SyntheticEvent, useEffect, useRef } from "react";
import { useHistory } from "react-router";

import CloseIcon from "web/assets/icons/close.svg";

import classify from "web/classify";
import { PropsWithClasses } from "web/types/Common";

import defaultStyles from "./modal.scss";

const [initial, animate, exit] = [
  { opacity: 0, y: 200 },
  { opacity: 1, y: 0 },
  { opacity: 0, y: -200 },
];

interface IDesktopModalProps {
  component?: ElementType;
  closeAction?: () => void;
}

const DesktopModal: FC<PropsWithClasses<IDesktopModalProps>> = ({
  classes = {},
  component: Component = null,
  closeAction = () => {},
}) => {
  const modalRef = useRef<HTMLInputElement>(null);
  const history = useHistory();

  const documentClickHandler = (e: SyntheticEvent) => {
    const modalElement = modalRef.current;
    const clickedElement = e.target;

    if (!modalElement?.contains(clickedElement as Node)) {
      closeAction();
    }
  };

  useEffect(() => {
    return history.listen(() => {
      if (history.action === "POP") {
        setTimeout(() => {
          closeAction();
        }, 500);
      }
    });
  }, [history]);

  return Component ? (
    <AnimatePresence>
      <motion.div
        className={classes.root}
        initial={initial}
        animate={animate}
        exit={exit}
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
        onClick={documentClickHandler}
      >
        <div className={classes.content} role="document" ref={modalRef}>
          {typeof Component === "function" ? (
            <Component closeAction={closeAction} />
          ) : (
            Component
          )}
          <button
            type="button"
            className={classes.closeButton}
            onClick={closeAction}
            data-t1="close_modal_button"
          >
            <CloseIcon className={classes.closeIcon} />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  ) : null;
};

export default classify(defaultStyles)(DesktopModal);
